import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import { connect } from 'react-redux';
import {
  getBooking,
  // getImage,
} from 'actions/events';
import EventDetails from './EventDetails';
// import BookingDetails from './BookingDetails';
import EventHeaderDetail from './EventHeaderDetail';
import { CatereaseCpReceived, ResetCatereaseCp } from '../reducers/caterease';

const styles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0 2%',
  },
});
// Removed TypeScript type alias as this is a JavaScript file

class Event extends Component {
  state = { bookingId: 0, imgSrc: '' };

  componentDidMount() {
    const bookingIdFromUrl = this.props.match.params.bookingId;
    const { uuid, history } = this.props;

    if (uuid !== bookingIdFromUrl) {
      this.props.CatereaseCpReceived(bookingIdFromUrl);
      window.location.reload(); //reload the page to ensure the oidc user is reloaded with the guest token
    }

    this.props.getBooking(uuid).then(booking => {
      if (booking && booking.error) {
        history.push(`/error/${booking.error} ${uuid}`);
      }
      this.setState({ bookingId: booking.eventLinkNumber });
    });
    this.loadImage();
  };

  componentDidUpdate(prevProps) {
    if (prevProps.booking !== this.props.booking) {
      this.loadImage();
    }
  };

  loadImage = () => {
    if (!this.props.booking) {
      return;
    }
    /*
    this.props.getImage(this.props.booking.id).then(image => {
      if (image.content) {
        const imgSrc = `data:image/gif;base64, ${image.content}`;

        this.setState({ imgSrc });
      };
    });*/
  };

  render() {
    const {
      classes,
      match,
      booking,
    } = this.props;
    const { bookingId, imgSrc } = this.state;

    if (!bookingId || !match || !match.params || booking.eventLinkNumber !== bookingId) {

      return null; //render nothing until the correct booking is loaded
    }

    return (
      <div>
        <EventHeaderDetail booking={booking} imgSrc={imgSrc} />
        <div className={classes.container}>
          <EventDetails booking={booking} />
          {/* <BookingDetails bookingId={booking.id} /> */}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  getBooking,
  CatereaseCpReceived,
  ResetCatereaseCp,
  // getImage,
};

const mapStateToProps = state => ({
  booking: !!state.api.booking ? state.api.booking : {},
  uuid: state.caterease ? state.caterease.catereaseCP : null,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Event));
